import http from "../http-common";
/* eslint-disable no-console */

export default {
    getGameDefinitions(success, error) {
        http
          .get("/game-definitions")
          .then(response => {
              console.log(response.data);
              success(response.data); // JSON are parsed automatically.
          })
          .catch(e => {
            console.log(e);
            error(e);
          });
      },
      addGameDefinition(gameDefinition, success, error) {
        http.post("/game-definitions", gameDefinition).then(response => {
          success(response.data);
        })
        .catch(e => {
          error(e);
        });
      }
}